// extracted by mini-css-extract-plugin
module.exports = {"policyCard":"policyCard_policyCard__iqHEc","card":"policyCard_card__f3IzJ","icon":"policyCard_icon__HecUa","label":"policyCard_label__9jq8R"};